<template>
  <div ref="pieChartWrapper" class="h-16 w-16 shrink-0" data-cy="mlh-ratio-pie-chart"></div>
</template>

<script lang="ts" setup>
import { init, type EChartsType } from 'echarts';
import { shallowRef, ref, onMounted, computed } from 'vue';

import designTokens from '@regenerativ/regenerativ-presets/tailwind/mylight150.js';

const { colors } = designTokens.theme;

const pieChartOptions = {
  title: {
    textStyle: {
      color: colors.cime.black.DEFAULT,
      fontWeight: 500,
      fontFamily: 'Inter',
      fontSize: 14,
      lineHeight: 20,
    },
    left: 'center',
    top: 'center',
  },
  grid: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  series: [
    {
      type: 'pie',
      label: { show: false },
      clockwise: true,
      emphasis: { disabled: true },
      radius: ['75%', '100%'],
    },
  ],
};

const pieChart = shallowRef<EChartsType | null>(null);
const pieChartWrapper = ref('pieChart');

type Props = {
  portion: number;
  total: number;
  legend: string;
};

const props = defineProps<Props>();

const getPieChartData = computed(() => {
  return [
    {
      value: props.portion,
      color: colors.secondary.DEFAULT,
    },
    {
      value: Math.ceil(props.total - props.portion),
      color: colors.secondary['100'],
    },
  ];
});

const initAndSetPieChart = () => {
  pieChart.value = init(pieChartWrapper.value as unknown as HTMLElement);

  const data = getPieChartData.value.map(({ value, color }) => ({
    value,
    itemStyle: { color },
  }));

  pieChart.value.setOption({
    ...pieChartOptions,
    title: {
      ...pieChartOptions.title,
      text: props.legend,
    },
    series: [
      {
        ...pieChartOptions.series[0],
        data,
      },
    ],
  });
};

onMounted(() => {
  initAndSetPieChart();
});
</script>
